<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'level', 'isDisabled'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    },
    level() {
      this.getOptions();
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/partnerLevel/all')
        .then((res) => {
          this.loading = false;
          this.options = res.data
            .filter((p) => {
              if (this.level) {
                return p.level == this.level;
              }
              return true;
            })
            .map((b) => {
              return { value: b.id, label: b.name };
            });
          this.value = this.modelValue || null;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
